import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { Scaffold } from "../registry/new-york/ui/scaffold";
import InstallationPage from "@/pages/docs/installation/page";
import BrandPage from "@/pages/docs/brand/page";
import BrandLogoPage from "@/pages/docs/brand/logo/page";
import BrandVoicePage from "@/pages/docs/brand/voice/page";
import DocsTokensColors from "@/pages/docs/tokens/colors/page";
import DocsTokensTypography from "@/pages/docs/tokens/typography/page";
import DocsTokensSpacing from "@/pages/docs/tokens/spacing/page";
import DocsTokensAnimation from "@/pages/docs/tokens/animation/page";
import DocsFoundations from "@/pages/docs/foundations/page";
import DocsFoundationsLayout from "@/pages/docs/foundations/layout/page";
import DocsAccessibility from "@/pages/docs/accessibility/page";
import DocsGuidelines from "@/pages/docs/guidelines/page";
import DocsPerformance from "@/pages/docs/performance/page";
import DocsI18n from "@/pages/docs/i18n/page";
import DocsPatternsForms from "@/pages/docs/patterns/forms/page";
import DocsComponentsAccordion from "@/pages/docs/components/accordion/page";
import DocsComponentsAlert from "@/pages/docs/components/alert/page";
import DocsComponentsAvatar from "@/pages/docs/components/avatar/page";
import DocsComponentsBadge from "@/pages/docs/components/badge/page";
import DocsComponentsBreadcrumb from "@/pages/docs/components/breadcrumb/page";
import DocsComponentsButton from "@/pages/docs/components/button/page";
import DocsComponentsCalendar from "@/pages/docs/components/calendar/page";
import DocsComponentsCard from "@/pages/docs/components/card/page";
import DocsComponentsCheckbox from "@/pages/docs/components/checkbox/page";
import DocsComponentsDataTable from "@/pages/docs/components/data-table/page";
import DocsComponentsDatePicker from "@/pages/docs/components/date-picker/page";
import DocsComponentsDateRangePicker from "@/pages/docs/components/date-range-picker/page";
import DocsComponentsDialog from "@/pages/docs/components/dialog/page";
import DocsComponentsDropdownMenu from "@/pages/docs/components/dropdown-menu/page";
import DocsComponentsEmptyState from "@/pages/docs/components/empty-state/page";
import DocsComponentsErrorBoundary from "@/pages/docs/components/error-boundary/page";
import DocsComponentsFilterBuilder from "@/pages/docs/components/filter-builder/page";
import DocsComponentsFormErrorSummary from "@/pages/docs/components/form-error-summary/page";
import DocsComponentsFormField from "@/pages/docs/components/form-field/page";
import DocsComponentsFormSection from "@/pages/docs/components/form-section/page";
import DocsComponentsInput from "@/pages/docs/components/input/page";
import DocsComponentsKanban from "@/pages/docs/components/kanban/page";
import DocsComponentsLabel from "@/pages/docs/components/label/page";
import DocsComponentsLoadingState from "@/pages/docs/components/loading-state/page";
import DocsComponentsLogo from "@/pages/docs/components/logo/page";
import DocsComponentsModal from "@/pages/docs/components/modal/page";
import DocsComponentsPageContainer from "@/pages/docs/components/page-container/page";
import DocsComponentsPagination from "@/pages/docs/components/pagination/page";
import DocsComponentsPopover from "@/pages/docs/components/popover/page";
import DocsComponentsProgress from "@/pages/docs/components/progress/page";
import DocsComponentsRadioGroup from "@/pages/docs/components/radio-group/page";
import DocsComponentsRangeCalendar from "@/pages/docs/components/range-calendar/page";
import DocsComponentsScaffold from "@/pages/docs/components/scaffold/page";
import DocsComponentsScrollArea from "@/pages/docs/components/scroll-area/page";
import DocsComponentsSearchBox from "@/pages/docs/components/search-box/page";
import DocsComponentsSection from "@/pages/docs/components/section/page";
import DocsComponentsSectionCard from "@/pages/docs/components/section-card/page";
import DocsComponentsSelect from "@/pages/docs/components/select/page";
import DocsComponentsSeparator from "@/pages/docs/components/separator/page";
import DocsComponentsSheet from "@/pages/docs/components/sheet/page";
import DocsComponentsSidebar from "@/pages/docs/components/sidebar/page";
import DocsComponentsSkeleton from "@/pages/docs/components/skeleton/page";
import DocsComponentsSpinner from "@/pages/docs/components/spinner/page";
import DocsComponentsStack from "@/pages/docs/components/stack/page";
import DocsComponentsStatePatterns from "@/pages/docs/components/state-patterns/page";
import DocsComponentsSwitch from "@/pages/docs/components/switch/page";
import DocsComponentsTabs from "@/pages/docs/components/tabs/page";
import DocsComponentsText from "@/pages/docs/components/text/page";
import DocsComponentsTextarea from "@/pages/docs/components/textarea/page";
import DocsComponentsToast from "@/pages/docs/components/toast/page";
import DocsComponentsTooltip from "@/pages/docs/components/tooltip/page";
import DocsComponentsVerticalTabs from "@/pages/docs/components/vertical-tabs/page";
import DocsComponentsCommand from "@/pages/docs/components/command/page";
import DocsComponentsCombobox from "@/pages/docs/components/combobox/page";
import DocsHooks from "@/pages/docs/hooks/page";
import DocsBlocksAgGrid from "@/pages/docs/blocks/ag-grid/page";
import DocsBlocksDataTable from "@/pages/docs/blocks/data-table/page";
import DocsBlocksListing from "@/pages/docs/blocks/listing/page";
import DocsBlocksFilterBuilder from "@/pages/docs/blocks/filter-builder/page";
import DocsBlocksDatePicker from "@/pages/docs/blocks/date-picker/page";
import DocsBlocksDateRangePicker from "@/pages/docs/blocks/date-range-picker/page";
import DocsBlocksModal from "@/pages/docs/blocks/modal/page";
import DocsBlocksSidebar from "@/pages/docs/blocks/sidebar/page";
import DocsBlocksTopbar from "@/pages/docs/blocks/topbar/page";
import DocsBlocksHorizontalTabs from "@/pages/docs/blocks/horizontal-tabs/page";
import DocsBlocksVerticalTabs from "@/pages/docs/blocks/vertical-tabs/page";
import DocsBlocksPagination from "@/pages/docs/blocks/pagination/page";
import DocsBlocksPageHeader from "@/pages/docs/blocks/page-header/page";
import DocsThemes from "@/pages/docs/themes/page";
import DocsLayout from "@/pages/docs/layout";
import DocsPage from "@/pages/docs/page";
import HomePage from "@/pages/page";

// --- Page Templates ---
import DashboardPage from "@/pages/templates/dashboard/DashboardPage";
import ListingPage from "@/pages/templates/listing/ListingPage";
import DetailPage from "@/pages/templates/detail/DetailPage";
import { ApprovalPage } from "@/pages/templates/approval/ApprovalPage";
import { SettingsPage } from "@/pages/templates/settings/SettingsPage";

// --- Chart Doc Pages ---
import DocsChartsOverview from "@/pages/docs/charts/page";
import DocsChartsBar from "@/pages/docs/charts/bar/page";
import DocsChartsLine from "@/pages/docs/charts/line/page";
import DocsChartsArea from "@/pages/docs/charts/area/page";
import DocsChartsPie from "@/pages/docs/charts/pie/page";
import DocsChartsDonut from "@/pages/docs/charts/donut/page";
import DocsChartsGauge from "@/pages/docs/charts/gauge/page";
import DocsChartsWaterfall from "@/pages/docs/charts/waterfall/page";
import DocsChartsTreemap from "@/pages/docs/charts/treemap/page";
import DocsDashboardGrid from "@/pages/docs/charts/dashboard-grid/page";

// --- Motion Doc Pages ---
import MotionSystemPage from "@/pages/docs/motion/page";
import MicroInteractionsPage from "@/pages/docs/motion/micro/page";

// --- AI Assistant Doc Pages ---
import DocsAiBoilerplate from "@/pages/docs/ai/boilerplate/page";
import DocsAiInstructions from "@/pages/docs/ai/instructions/page";

// Detail page wrapper — provides default invoiceId for demo
function DetailPageDemo() {
  return <DetailPage invoiceId="INV-2024-0892" />;
}

function RootShell() {
  return (
    <Scaffold className="h-screen overflow-hidden">
      <Outlet />
    </Scaffold>
  );
}

export default function App() {
  return (
    <Routes>
      <Route element={<RootShell />}>
        <Route path="/" element={<HomePage />} />

        <Route path="/docs" element={<DocsLayout />}>
          <Route index element={<DocsPage />} />
          <Route path="installation" element={<InstallationPage />} />
          <Route path="brand" element={<BrandPage />} />
          <Route path="brand/logo" element={<BrandLogoPage />} />
          <Route path="brand/voice" element={<BrandVoicePage />} />
          <Route path="tokens/colors" element={<DocsTokensColors />} />
          <Route path="tokens/typography" element={<DocsTokensTypography />} />
          <Route path="tokens/spacing" element={<DocsTokensSpacing />} />
          <Route path="tokens/animation" element={<DocsTokensAnimation />} />
          <Route path="themes" element={<DocsThemes />} />
          <Route path="foundations" element={<DocsFoundations />} />
          <Route path="foundations/layout" element={<DocsFoundationsLayout />} />
          <Route path="accessibility" element={<DocsAccessibility />} />
          <Route path="guidelines" element={<DocsGuidelines />} />
          <Route path="performance" element={<DocsPerformance />} />
          <Route path="i18n" element={<DocsI18n />} />
          <Route path="patterns/forms" element={<DocsPatternsForms />} />

          <Route path="components/accordion" element={<DocsComponentsAccordion />} />
          <Route path="components/alert" element={<DocsComponentsAlert />} />
          <Route path="components/avatar" element={<DocsComponentsAvatar />} />
          <Route path="components/badge" element={<DocsComponentsBadge />} />
          <Route path="components/breadcrumb" element={<DocsComponentsBreadcrumb />} />
          <Route path="components/button" element={<DocsComponentsButton />} />
          <Route path="components/calendar" element={<DocsComponentsCalendar />} />
          <Route path="components/card" element={<DocsComponentsCard />} />
          <Route path="components/checkbox" element={<DocsComponentsCheckbox />} />
          <Route path="components/data-table" element={<DocsComponentsDataTable />} />
          <Route path="components/date-picker" element={<DocsComponentsDatePicker />} />
          <Route path="components/date-range-picker" element={<DocsComponentsDateRangePicker />} />
          <Route path="components/dialog" element={<DocsComponentsDialog />} />
          <Route path="components/dropdown-menu" element={<DocsComponentsDropdownMenu />} />
          <Route path="components/empty-state" element={<DocsComponentsEmptyState />} />
          <Route path="components/error-boundary" element={<DocsComponentsErrorBoundary />} />
          <Route path="components/filter-builder" element={<DocsComponentsFilterBuilder />} />
          <Route path="components/form-error-summary" element={<DocsComponentsFormErrorSummary />} />
          <Route path="components/form-field" element={<DocsComponentsFormField />} />
          <Route path="components/form-section" element={<DocsComponentsFormSection />} />
          <Route path="components/input" element={<DocsComponentsInput />} />
          <Route path="components/kanban" element={<DocsComponentsKanban />} />
          <Route path="components/label" element={<DocsComponentsLabel />} />
          <Route path="components/loading-state" element={<DocsComponentsLoadingState />} />
          <Route path="components/logo" element={<DocsComponentsLogo />} />
          <Route path="components/modal" element={<DocsComponentsModal />} />
          <Route path="components/page-container" element={<DocsComponentsPageContainer />} />
          <Route path="components/pagination" element={<DocsComponentsPagination />} />
          <Route path="components/popover" element={<DocsComponentsPopover />} />
          <Route path="components/progress" element={<DocsComponentsProgress />} />
          <Route path="components/radio-group" element={<DocsComponentsRadioGroup />} />
          <Route path="components/range-calendar" element={<DocsComponentsRangeCalendar />} />
          <Route path="components/scaffold" element={<DocsComponentsScaffold />} />
          <Route path="components/scroll-area" element={<DocsComponentsScrollArea />} />
          <Route path="components/search-box" element={<DocsComponentsSearchBox />} />
          <Route path="components/section" element={<DocsComponentsSection />} />
          <Route path="components/section-card" element={<DocsComponentsSectionCard />} />
          <Route path="components/select" element={<DocsComponentsSelect />} />
          <Route path="components/separator" element={<DocsComponentsSeparator />} />
          <Route path="components/sheet" element={<DocsComponentsSheet />} />
          <Route path="components/sidebar" element={<DocsComponentsSidebar />} />
          <Route path="components/skeleton" element={<DocsComponentsSkeleton />} />
          <Route path="components/spinner" element={<DocsComponentsSpinner />} />
          <Route path="components/stack" element={<DocsComponentsStack />} />
          <Route path="components/state-patterns" element={<DocsComponentsStatePatterns />} />
          <Route path="components/switch" element={<DocsComponentsSwitch />} />
          <Route path="components/tabs" element={<DocsComponentsTabs />} />
          <Route path="components/text" element={<DocsComponentsText />} />
          <Route path="components/textarea" element={<DocsComponentsTextarea />} />
          <Route path="components/toast" element={<DocsComponentsToast />} />
          <Route path="components/tooltip" element={<DocsComponentsTooltip />} />
          <Route path="components/vertical-tabs" element={<DocsComponentsVerticalTabs />} />
          <Route path="components/command" element={<DocsComponentsCommand />} />
          <Route path="components/combobox" element={<DocsComponentsCombobox />} />

          <Route path="hooks" element={<DocsHooks />} />

          <Route path="blocks/ag-grid" element={<DocsBlocksAgGrid />} />
          <Route path="blocks/data-table" element={<DocsBlocksDataTable />} />
          <Route path="blocks/listing" element={<DocsBlocksListing />} />
          <Route path="blocks/filter-builder" element={<DocsBlocksFilterBuilder />} />
          <Route path="blocks/date-picker" element={<DocsBlocksDatePicker />} />
          <Route path="blocks/date-range-picker" element={<DocsBlocksDateRangePicker />} />
          <Route path="blocks/modal" element={<DocsBlocksModal />} />
          <Route path="blocks/sidebar" element={<DocsBlocksSidebar />} />
          <Route path="blocks/topbar" element={<DocsBlocksTopbar />} />
          <Route path="blocks/horizontal-tabs" element={<DocsBlocksHorizontalTabs />} />
          <Route path="blocks/vertical-tabs" element={<DocsBlocksVerticalTabs />} />
          <Route path="blocks/pagination" element={<DocsBlocksPagination />} />
          <Route path="blocks/page-header" element={<DocsBlocksPageHeader />} />

          {/* ======= Charts ======= */}
          <Route path="charts" element={<DocsChartsOverview />} />
          <Route path="charts/bar" element={<DocsChartsBar />} />
          <Route path="charts/line" element={<DocsChartsLine />} />
          <Route path="charts/area" element={<DocsChartsArea />} />
          <Route path="charts/pie" element={<DocsChartsPie />} />
          <Route path="charts/donut" element={<DocsChartsDonut />} />
          <Route path="charts/gauge" element={<DocsChartsGauge />} />
          <Route path="charts/waterfall" element={<DocsChartsWaterfall />} />
          <Route path="charts/treemap" element={<DocsChartsTreemap />} />
          <Route path="charts/dashboard-grid" element={<DocsDashboardGrid />} />

          {/* ======= Page Templates ======= */}
          <Route path="templates/dashboard" element={<DashboardPage />} />
          <Route path="templates/listing" element={<ListingPage />} />
          <Route path="templates/detail" element={<DetailPageDemo />} />
          <Route path="templates/approval" element={<ApprovalPage />} />
          <Route path="templates/settings" element={<SettingsPage />} />

          {/* ======= Motion ======= */}
          <Route path="motion" element={<MotionSystemPage />} />
          <Route path="motion/micro" element={<MicroInteractionsPage />} />

          {/* ======= AI Assistant ======= */}
          <Route path="ai/boilerplate" element={<DocsAiBoilerplate />} />
          <Route path="ai/instructions" element={<DocsAiInstructions />} />
        </Route>
      </Route>
    </Routes>
  );
}